import { get, patch } from '../apiService';
import type { Quiz, PatchQuizPayload } from '../../types/content/quiz';

export async function getQuizByCourseId(courseId: string): Promise<Quiz> {
  return get<Quiz>(`/course/${courseId}/quiz?expand=quizQuestions`);
}

export async function patchQuiz(id: string, data: PatchQuizPayload): Promise<Quiz> {
  return patch<Quiz>(`/quiz/${id}`, data);
}
